import _ from "underscore";
import { template, className, regions } from "core/decorators";
import App from "app";
import SchemaSelectionTemplate from "./templates/schema-selection.template.html";
import "datatables.net-dt";
import "datatables.net-scroller-dt";
import InlineHelpMarionetteContainer from "../inline-help-container";
import TableWrapperSelection from "./source-wizard-react-view/table-wrapper-selection/table-wrapper-selection";
import MarionetteWrapper from "../../../../../marionette-wrapper-for-react";

@className("card schema-selection-view")
@template(SchemaSelectionTemplate)
@regions({
    schemaSelection: "#table-wrapper-selection-react-container"
})
export default class SchemaSelectionView extends InlineHelpMarionetteContainer {
    initialize() {
        let model = App.reqres.request("get:wizard:model");
        this.model = model;
        super.initialize("select-schemas");
    }

    onRender() {
        const SchemaSelectionReactView = MarionetteWrapper(TableWrapperSelection, {
            schemas: this.model.get("schemas").models,
            whatIsInside: this.model.get("whatsInside")
        });

        this.getRegion("schemaSelection").show(SchemaSelectionReactView);
    }

    onShow() {
        super.onShow();
    }

    canMoveForward() {
        return new Promise(function(resolve, reject) {
            resolve();
        });
    }

    onBeforeDestroy() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
}
